import { createContext, useContext, useReducer } from 'react';
import { LoginState, LoginReducer, ACTION_TYPES } from './login-reducer';
import { IPreAuthenticationRequest } from '../../../model/security/request/pre-authentication-request';
import { IPreAuthenticationResponse } from '../../../model/security/response/pre-authentication-response';
import { IAuthenticationRequest } from '../../../model/security/request/authentication-request';
import ApplicationAppService from '../../../application/platform/application-app-service';

const LoginContext = createContext<LoginState | undefined>(undefined);
const LoginDispatchContext = createContext({} as any);

const LoginProvider = ({ children }: { children: React.ReactNode }) => {
    const applicationData = ApplicationAppService.getApplicationData();

    const initialState: LoginState = {
        preAuthenticationRequest: {
            type: 1,
            user: "",
            password: "",
            multiTenantId: applicationData.multitenant
        } as IPreAuthenticationRequest,
        preAuthenticationResponse: {} as IPreAuthenticationResponse,
        authenticationRequest: {
            type: 1,
            remember: false,
            module: applicationData.moduleId
        } as IAuthenticationRequest,
        showPassword: false,
        loading: false,
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(LoginReducer, initialState);

    return (
        <LoginContext.Provider value={state}>
            <LoginDispatchContext.Provider value={dispatch}>
                {children}
            </LoginDispatchContext.Provider>
        </LoginContext.Provider>
    );
}

const useLoginState = () => {
    const context = useContext(LoginContext);
    if (context === undefined) {
        throw new Error('useLoginState must be used within a LoginProvider');
    }
    return context;
}

const useLoginDispatch = () => {
    const context = useContext(LoginDispatchContext);
    if (context === undefined) {
        throw new Error('useLoginDispatch must be used within a LoginProvider');
    }
    return context;
}

export { LoginProvider, useLoginDispatch, useLoginState, ACTION_TYPES };
